<template>
  <div>
    <div class="demo__font--20 demo__weight--600 demo__color--black">
      {{ $t("Reset password") }}
    </div>
    <div class="demo__font--16 demo__color--black demo__margin-top--10">
      <template v-if="!emailSent">
        <span class="demo__weight--400">
          {{ $t("Reset password about") }}
        </span>
      </template>
      <template v-else>
        <span class="demo__weight--400">{{
          $t("Reset password about after")
        }}</span>
        <span class="demo__weight--500"> {{ form.email }}</span>
      </template>
    </div>
    <a-form-model
      v-if="!emailSent"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      class="demo__margin-top--24 demo__FormModal"
    >
      <a-form-model-item
        ref="email"
        prop="email"
        :label="$t('Email')"
        v-bind:class="{ 'has-error': login_result }"
      >
        <a-input
          v-model="_email"
          class="demo__input"
          @keyup.enter="onSubmit"
          @blur="
            () => {
              $refs.email.onFieldBlur();
            }
          "
        />
        <div class="login-result" v-show="login_result">
          {{ login_result ? login_result.text : false }}
        </div>
      </a-form-model-item>

      <a-form-model-item class="demo__margin-top--24">
        <a-button
          class="demo__button demo__button--base demo__button--full"
          @click="onSubmit"
        >
          {{ $t("Reset password v2") }}
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <div>
      <div
        v-if="emailSent && installation === 'ru'"
        class="demo__margin-top--24 demo__font--14 demo__weight--600 demo__flex demo__flex-middle"
      >
        <span class="demo__color--black">
          {{ $t("Email not come?") }}
        </span>

        <a
          class="demo__color--brandPrimary demo__margin-left--5"
          href="https://t.me/thirdopinion_support_bot"
          target="_blank"
        >
          {{ $t("Write to support") }}
        </a>
      </div>
      <AuthLockBlock v-if="emailSent">
        <a-button
          class="demo__button demo__button--base demo__button--full demo__margin-top--24"
        >
          {{ $t("Back to login") }}
        </a-button>
      </AuthLockBlock>
    </div>
    <div class="demo__margin-top--24" v-if="!emailSent">
      <div class="demo__color--brandPrimary demo__font-14 demo__weight--600">
        <AuthLockBlock class="demo__pointer demo__inline">
          {{ $t("Back to prev page") }}</AuthLockBlock
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      a: window.navigator.userAgent,
      login_result: undefined,
      form: {
        email: undefined,
      },
      emailSent: false,
      installation: process.env.VUE_APP_INSTALLATION,
    };
  },
  created() {
    document.title = this.$t("Login title");
  },
  computed: {
    ...mapGetters(["user", "api", "agent", "isMobile", "userLinks"]),
    _email: {
      get: function () {
        return this.form.email;
      },
      set: function (val) {
        this.form.email = val.replaceAll(/ /g, "");
      },
    },
    rules() {
      return {
        email: [
          {
            required: true,
            message: this.$t("Rem password"),
            trigger: "change",
          },
          {
            pattern:
              /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
            message: this.$t("Not valid email"),
            trigger: "change",
          },
        ],
      };
    },
    localhost() {
      return window.location.hostname === "localhost" ? true : false;
    },
  },
  watch: {
    form: {
      handler() {
        this.login_result = undefined;
      },
      deep: true,
    },
  },
  mounted() {
    this.$accessModule("reset_password", this);
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.resetPassword();
        } else {
          this.$debug(
            "Форма восстановления пароля заполнена неверно!",
            "error"
          );
          return false;
        }
      });
    },
    resetPassword() {
      this.api
        .resetPassword({
          data: {
            email: this.form.email,
          },
        })
        .then((response) => {
          if (response.data.status && response.data.status === "OK") {
            this.emailSent = true;
          } else {
            throw response.data;
          }
        })
        .catch((error) => {
          const error_message = error.message;
          let text;
          switch (error_message) {
            case "Network Error":
              text = this.$t("Auth error network");
              break;

            case "Request failed with status code 400":
              text = this.$t("Not found email");
              break;

            default:
              text = this.$t("Auth error unknown");
              break;
          }
          this.$debug(
            "Ошибка восстановления пароля " + text,
            "error",
            error_message
          );
          this.login_result = {
            text: text,
          };
        });
    },
  },
};
</script>
